import { IKnmDictionary } from 'APIPackage/KnmModule/interfaces/IKnmDictionary';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

export type CreatePreventionModalDTO = {
  startDate: string;
  stopDate: string;
  supervisionType: IKnmDictionary;
  knoOrganization: IKnmDictionary;
  federalLaw: IKnmDictionary;
  profKind: IKnmDictionary;
  reason: {
    type: IKnmDictionary;
  };
  prosecutorUUID: string;
};

export function convertCreateModalPreventionToDTO(values: ICreatePreventionForm): CreatePreventionModalDTO {
  return {
    startDate: values.startDate,
    stopDate: values.stopDate,
    supervisionType: values.supervisionTypePm.value,
    knoOrganization: values.knoOrganizationPm.value,
    federalLaw: values.federalLaw.value,
    profKind: values.profKind.value,
    reason: convertReason(values),
    prosecutorUUID: values.prosecutorOrganization.ervkVersionUuid ?? '',
  };
}

function convertReason(values: ICreatePreventionForm) {
  return {
    type: {
      dictId: DictionaryUUIDsEnum.ERVK,
      dictVersionId: values.reason.type.ervkUuid,
    },
  };
}
